module.exports = __webpack_public_path__ + "media/components/weather-icon/static/dayrainshowers-145c1cc62424f914bac48bf46cc05bfc.webp";